import React from 'react';
import {
  SurgicalMeshDetailsContainer,
  TableContainer,
  CTAButton,
  SurgicalMeshDetailsTitle,
  GridBox,
} from './styled';
import { useNavigate } from 'react-router-dom';
import { surgicalMeshBoxes } from './constants';

const SurgicalMeshDetails: React.FC = () => {
  const navigate = useNavigate();
  return (
    <SurgicalMeshDetailsContainer>
        <SurgicalMeshDetailsTitle>Polypropylene Mesh Sizes</SurgicalMeshDetailsTitle>
      <TableContainer>
        {surgicalMeshBoxes.map(b => <GridBox key={b}>{b}</GridBox>)}
      </TableContainer>
      <CTAButton onClick={() => navigate('/?scroll=contact')}>Get In touch</CTAButton>
    </SurgicalMeshDetailsContainer>
  );
};

export default SurgicalMeshDetails;
